export default __webpack_public_path__ + "static/media/art-pro-blk-banner-3.3c147df4.jpg";